import { isDevMode, isStagMode } from '../utils'

const host = window.location.host
const modePrefix = isDevMode(host) ? 'dev-' : isStagMode(host) ? 'stg-' : ''
// const modePrefix = 'https://taekwang.hrms-jobseeker.software/'

const prefix = `https://${modePrefix}`

// Define the base API URL
const { BASE_API_URL } = window.__APP__

// Function to generate API URLs
const generate = (service: string) => `${prefix}hrms-${service}.${BASE_API_URL}`

// Define master data API URLs
// export const API_AUTH_URL = import.meta.env.VITE_API_AUTH_URL || generate('auth')
// Define sso utk prod
export const API_AUTH_URL =
  import.meta.env.VITE_API_AUTH_URL || (isDevMode(host) ? generate('auth') : 'https://auth-sso.api-jobseeker.site/')
export const API_MASTER_URL = import.meta.env.VITE_API_MASTER_URL || `https://master.${BASE_API_URL}`

// Define other API URLs using the generate function
export const API_ORGANIZATION_URL = import.meta.env.VITE_API_ORGANIZATION_URL || generate('taekwang')
export const API_VACANCY_URL = import.meta.env.VITE_API_VACANCY_URL || generate('taekwang')
export const API_EMPLOYEE_URL = import.meta.env.VITE_API_EMPLOYEE_URL || generate('taekwang')
export const API_ATTENDANCE_URL = import.meta.env.VITE_API_ATTENDANCE_URL || generate('taekwang')
export const API_APPLICANT_URL = import.meta.env.VITE_API_APPLICANT_URL || generate('taekwang')
export const API_CANDIDATE_URL = import.meta.env.VITE_API_CANDIDATE_URL || generate('taekwang')
export const API_PROCESS_URL = import.meta.env.VITE_API_PROCESS_URL || generate('taekwang')
export const API_S3_URL = import.meta.env.VITE_API_S3_URL || 'https://basic-s3.api-jobseeker.site'
export const API_PAYROLL_URL = import.meta.env.VITE_API_PAYROLL_URL || generate('taekwang')
export const API_CMS_URL = import.meta.env.VITE_API_CMS_URL || generate('cms')
export const API_REPORT_URL = import.meta.env.VITE_API_REPORT_URL || generate('taekwang')
export const API_DASHBOARD_URL = import.meta.env.VITE_API_DASHBOARD_URL || generate('taekwang')
export const API_CANDIDATE_EXPLORE_URL = import.meta.env.VITE_API_CANDIDATE_EXPLORE_URL || 'https://candidate.api-jobseeker.site'
export const API_NOTIFICATION_URL = import.meta.env.VITE_API_NOTIFICATION_URL || generate('notification')
export const API_REIMBURSEMENT_URL = import.meta.env.VITE_API_REIMBURSEMENT_URL || generate('taekwang')
export const API_MASTER_URL2 = import.meta.env.VITE_API_REIMBURSEMENT_URL || generate('taekwang')
export const API_AUTHORITY_URL = import.meta.env.VITE_API_REIMBURSEMENT_URL || generate('taekwang')
export const API_SOCKET_URL = import.meta.env.VITE_API_SOCKET_URL || 'wss://dev-socket.jobseeker.software'
export const API_BASIC_URL = import.meta.env.VITE_API_JOBSEEKER_URL || generate('basic')
export const API_TAEKWANG_URL = import.meta.env.VITE_API_TAEKWANG_URL || generate('taekwang')
export const API_SECURITY_URL = import.meta.env.VITE_API_SECURITY_URL || generate('taekwang')
